export interface OrganizationRef {
  id: string;
  name: string;
}

export type EventAccessProbe = (eventId: string, organizationId: string) => Promise<boolean>;

export const probeBuyerEventAccess: EventAccessProbe = async (eventId, organizationId) => {
  const response = await fetch(`${import.meta.env.VITE_BFF_BASE_URL}/api/buyer/events/${eventId}`, {
    credentials: "include",
    headers: { organizationId },
  });
  return response.ok;
};

export const organizationsThatCanOpen = async (
  eventId: string,
  candidates: OrganizationRef[],
  probe: EventAccessProbe,
): Promise<OrganizationRef[]> => {
  const verdicts = await Promise.all(candidates.map((org) => probe(eventId, org.id).catch(() => false)));
  return candidates.filter((_, index) => verdicts[index]);
};
